<!-- event Head -->
<div class="loader_session" *ngIf='loaderdata'>
    <div class="loader-4"><span></span>
  </div>
  </div>



<div class="event-header" style="background-image: url(assets/image/Group-1895.png)">
    <div class="event-heading">
        <div class="event-head">
            <h3>LINKS</h3>
        </div>
    </div>
</div>


<!-- links -->

<div class="container">
    <div class="header  mx-5">
        <h3>LINKS </h3>
        <p>Clicking on any of these links takes viewer off of the APS website. APS is not responsible for the content or
            security (or lack thereof) on any other website.</p>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col">No.</th>
                    <th scope="col">Link Name</th>
                    <th scope="col">Link Url</th>
                  
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let link of data; index as i; first as isFirst">
                <th>{{i+1}}</th>
                <td>{{link.linkname}}</td>
                <td><a href="{{link.linkurl}}" target="_blank">{{link.linkurl}}</a></td>

                </tr>

            </tbody>
        </table>

    </div>
</div>